import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class DishWasherIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 245.09 300">
                <g fill={color}>
                    <path
                        d="M0 287.19A12.81 12.81 0 0 0 12.81 300h219.48a12.81 12.81 0 0 0 12.81-12.81V66.6H0zM245.1 12.81A12.81 12.81 0 0 0 232.29 0H12.81A12.81 12.81 0 0 0 0 12.81v44.75h245.1z"
                        fill={color}
                    />
                    <circle cx={169.94} cy={28.78} r={11.31} fill={secondaryColor} />
                    <circle cx={211.92} cy={28.78} r={11.31} fill={secondaryColor} />
                    <path
                        d="M122.55 93.2a90.1 90.1 0 1 0 90.14 90.14 90.09 90.09 0 0 0-90.14-90.14zm72.41 93.16l.79-3.05a73.21 73.21 0 1 1-73.2-73.22 73.21 73.21 0 0 1 73.21 73.21z"
                        fill={secondaryColor}
                    />
                    <path
                        d="M91.84 241.93q1.45-19.15 2.91-38.29c.18-2.32.44-4.62.66-6.94a7.74 7.74 0 0 0-3.56-7.73c-5.48-3.57-7.36-8.58-6.81-15 .79-9.2 1.17-18.44 1.73-27.67 0-.72 0-1.45.15-2.16a2.28 2.28 0 0 1 2.53-2.14 2.3 2.3 0 0 1 2.18 2.52c-.05 2.12-.19 4.23-.3 6.34q-.48 9.59-1 19.18c-.09 1.94.86 3.17 2.49 3.27s2.78-1.14 2.83-3.15q.32-12.62.62-25.24c0-1.45.5-2.54 2-2.86 1.76-.36 3 .73 3.06 2.73.2 6.81.36 13.63.54 20.44 0 1.7 0 3.41.12 5.11.09 1.91 1.24 3.08 2.84 3s2.6-1.39 2.5-3.28q-.63-12.61-1.25-25.22c-.09-1.75.82-2.82 2.32-2.82s2.31 1 2.43 2.8q.42 7 .85 13.91c.35 5.82.75 11.64 1 17.47a12.94 12.94 0 0 1-5.91 12.06c-3.58 2.39-4.75 5.41-4.43 9.73 1.41 18.63 2.53 37.28 3.74 55.93a10.74 10.74 0 0 1-2.33 7.37 6.14 6.14 0 0 1-10.24-.38 11.68 11.68 0 0 1-2-7c.09-4 0-7.94 0-11.92zM141.65 207.23c-1-.09-1.81-.13-2.61-.25a4.57 4.57 0 0 1-4.18-4.45c.08-10.32-.15-20.67.56-31 .73-10.56 5-20.05 11.28-28.55a2.66 2.66 0 0 1 2-1c1.09.11 1 1.2 1 2.1 0 20.14-.1 40.28.05 60.42 0 5.92.83 11.83 1.21 17.76q.93 14.76 1.76 29.53c.16 2.89.31 5.78.29 8.67a9.68 9.68 0 0 1-3.17 7.32 6 6 0 0 1-9.19-1 10.52 10.52 0 0 1-2.19-6.79c.69-12.73 1.36-25.46 2.1-38.19.24-4.86.7-9.64 1.09-14.57z"
                        fill={secondaryColor}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(DishWasherIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/DishWasherIcon.js